module.exports = __webpack_public_path__ + "media/components/country-flag/static/fm-8f5aee029087feb4f607cfed1d75147f.svg";